import { Flex } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

// provides standard horizontal padding for the content that lives inside a grid cell.
export function ContentBlock({ children }: PropsWithChildren) {
  return (
    <Flex flexDirection="column" paddingY="0.5rem">
      {children}
    </Flex>
  );
}
